export default __webpack_public_path__ + "static/diwaliBanner-da216d834454925ea3389555db820fe9.webp";